export const DELETE_SPOT_LIST_REQUEST = 'DELETE_SPOT_LIST_REQUEST';

export const deleteSpotListRequest = ( id: string ) => ({
    type: DELETE_SPOT_LIST_REQUEST,
    payload: { id }
});
